import { IPaymentActions } from "../../../models"

export enum ConfirmStepTypeKeys {
  CONFIRM_NEW_RESERVATION = 'CONFIRM_NEW_RESERVATION',
  CONFIRMING_NEW_RESERVATION = 'CONFIRMING_NEW_RESERVATION',
  CONFIRM_NEW_RESERVATION_SUCCESSFUL = 'CONFIRM_NEW_RESERVATION_SUCCESSFUL',
  CONFIRM_NEW_RESERVATION_FAILED = 'CONFIRM_NEW_RESERVATION_FAILED'
}

export interface IConfirmNewReservationAction {
  type: typeof ConfirmStepTypeKeys.CONFIRM_NEW_RESERVATION,
  payload: {
    payOption: IPaymentActions,
  }
}

export interface ISetIsConfirmingNewReservationAction {
  type: typeof ConfirmStepTypeKeys.CONFIRMING_NEW_RESERVATION
}

export interface IConfirmNewReservationSuccessfulAction {
  type: typeof ConfirmStepTypeKeys.CONFIRM_NEW_RESERVATION_SUCCESSFUL,
  payload: boolean
}

export interface IConfirmNewReservationFailedAction {
  type: typeof ConfirmStepTypeKeys.CONFIRM_NEW_RESERVATION_FAILED
}

export type ConfirmStepActionTypes =
  | IConfirmNewReservationAction
  | ISetIsConfirmingNewReservationAction
  | IConfirmNewReservationSuccessfulAction
  | IConfirmNewReservationFailedAction
